<div class="kpi-item">
  <div class="tooltip-container">
    <achoo-icon-tooltip [tooltipMsg]="titleTooltip"></achoo-icon-tooltip>
  </div>
  <div class="kpi-info">
    <span class="kpi-value" *ngIf="!isPercentValue">{{kpi.value | thousandNumberSuffix}}</span>
    <span class="kpi-value" *ngIf="isPercentValue">{{ kpi.value | percentNumberSuffix:1 }}</span>
    <span class="kpi-name">{{kpi.name}}</span>
    <div class="badge kpi-percentage {{kpi.status}}" *ngIf="showStatus && kpi.percent !== null">
      <div class="arrow-icon">
        <div class="kpi-upwards">
          <svg width="14px" height="14px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <desc></desc>
            <defs>
              <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
            </defs>
            <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Keyicons/Chevron-up">
                <g id="Chevron-down">
                  <rect id="Transparent" fill-opacity="0.01" fill="#FFFFFF" x="0" y="0" width="20" height="20"></rect>
                  <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1"></use>
                  </mask>
                  <use id="Mask" fill="#54D89F" fill-rule="nonzero" transform="translate(10.040000, 10.120000) rotate(-180.000000) translate(-10.040000, -10.120000) " xlink:href="#path-1"></use>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div class="kpi-downwards">
          <svg width="14px" height="14px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
              <polygon id="path-1" points="7.21 8 6.5 8.71 10.04 12.24 13.58 8.71 12.87 8 10.04 10.83"></polygon>
            </defs>
            <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Keyicons/Chevron-down" transform="rotate(0 10 10)">
                <g id="Chevron-down">
                  <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1"></use>
                  </mask>
                  <use id="Mask" fill="#EC506E" fill-rule="nonzero" xlink:href="#path-1"></use>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <span>{{ kpi.percent | percentNumberSuffix }}</span>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/new-kpi/new-kpi-item/new-kpi-item.component.html